module.exports = __webpack_public_path__ + "static/media/BM_TAE.f90e6179.svg";